<template>
  <footer>
    <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl">
      <div
        class="border-t border-gray-200 py-8 text-sm text-gray-500 text-center sm:text-left"
      >
        <span class="block sm:inline"
          >&copy; 2016-{{ new Date().getFullYear() }} Live Storms Media.
          &middot;</span
        >
        <span class="block sm:inline">All rights reserved. &middot;</span>
        <router-link to="/metrics" class="text-blue-600">
          Metrics
        </router-link>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "PageFooter"
};
</script>
